import type {
  CreditPackageDetailsFilter} from "@/__generated__/graphql";
import {
  CreditPackageDetailsByFiltersDocument
} from "@/__generated__/graphql";
import { useQuery } from "@apollo/client";

export const useCreditPackageDetailsByFiltersQuery = (
  filters: CreditPackageDetailsFilter,
) => {
  const result = useQuery(CreditPackageDetailsByFiltersDocument, {
    variables: {
      filters,
    },
  });

  const list =
    result.data?.CreditPackageDetailsByFilters.creditPackageDetails ?? [];

  return {
    ...result,
    list,
  };
};
